import { render, staticRenderFns } from "./rewardAndPRecordEdit.vue?vue&type=template&id=b1b36a4c&scoped=true&"
import script from "./rewardAndPRecordEdit.vue?vue&type=script&lang=js&"
export * from "./rewardAndPRecordEdit.vue?vue&type=script&lang=js&"
import style0 from "./rewardAndPRecordEdit.vue?vue&type=style&index=0&id=b1b36a4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b36a4c",
  null
  
)

component.options.__file = "rewardAndPRecordEdit.vue"
export default component.exports